// 、
export const ERROR_CODES = {
  // 系統錯誤
  SYSTEM_1000: 'success', // 操作成功
  SYSTEM_1001: 'error',   // 請求參數錯誤或缺失
  SYSTEM_1004: 'error',   // 登入驗證已過期，請重新登入
  SYSTEM_9999: 'error',   // 系統異常

  // 用戶相關錯誤
  USER_2020: 'error',     // 用戶不存在
  USER_2021: 'error',     // 用戶名格式不符規定
  USER_2022: 'error',     // 信箱格式不符規定
  USER_2023: 'error',     // 密碼格式不符規定
  USER_2024: 'error',     // 生日格式不符規定
  USER_2025: 'error',     // 註冊失敗，用戶年齡未滿十八歲
  USER_2026: 'error',     // 註冊失敗，信箱已經被註冊
  USER_2027: 'error',     // 驗證碼錯誤或已過期
  USER_2031: 'error',     // 登入失敗，驗證資訊錯誤
  USER_2032: 'error',     // 舊密碼錯誤
  USER_2033: 'error',     // 登入失敗，帳號已被停權
  USER_2034: 'error',     // 帳號已被停權，無法繼續操作（登入後才被停權，任何 API 都會回此碼）
  USER_2041: 'error',     // 註冊信箱驗證失敗，信箱已經被註冊
  USER_2042: 'error',     // 重設信箱驗證失敗，信箱不存在
  USER_2043: 'error',     // 驗證次數過於頻繁，請稍後再試
  USER_2049: 'error',     // 信箱驗證服務異常

  // 偶像相關錯誤
  IDOL_3041: 'error',     // 偶像暱稱已存在
  IDOL_3042: 'error',     // 偶像暱稱不可包含空格
  IDOL_3043: 'error',     // 已經檢舉過此偶像
  IDOL_3044: 'error',     // 此偶像已被停權或已刪除，無法操作

  // 貼文相關錯誤
  POST_4001: 'error',     // 貼文不存在
  POST_4003: 'error',     // 貼文已被下架
  POST_4019: 'error',     // 解鎖價格不可低於 1 FCoin
  POST_4020: 'error',     // 貼文已經解鎖
  POST_4021: 'error',     // 此貼文不需要付費解鎖
  POST_4022: 'error',     // 無法解鎖自己的貼文
  POST_4023: 'error',     // 無權限存取此貼文
  POST_4024: 'error',     // 已經檢舉過此貼文
  POST_4025: 'error',     // 預約發文時間不合法（不可是過去時間），或該貼文已公開不可再修改發布時間

  // 通訊相關錯誤
  CHAT_5001: 'error',     // 對方已關閉聊天私訊功能
  CHAT_5002: 'error',     // 對方僅允許訂閱用戶傳送訊息
  CHAT_5003: 'error',     // 對方已關閉打賞功能
  CHAT_5004: 'error',     // 不支援的檔案格式
  CHAT_5005: 'error',     // 檔案大小超過限制
  CHAT_5006: 'error',     // 尚未連接 Webhook，無法切換暫停狀態
  CHAT_5007: 'error',     // 已被對方封鎖。呼叫端自行處理（輸入區改顯示中性的「無法傳送」提示），不走 StatusModal，避免被封鎖方得知被封鎖

  // 錢包相關錯誤
  WALLET_8001: 'error',   // 充值金額低於最低限制
  WALLET_8002: 'error',   // 充值/提領訂單不存在
  WALLET_8003: 'error',   // 訂單狀態錯誤
  WALLET_8004: 'error',   // 提領金額低於最低限制
  WALLET_8005: 'error',   // 餘額不足
  WALLET_8006: 'error',   // 交易處理失敗
  WALLET_8007: 'error',   // 打賞金額不可低於 1 FCoin
  WALLET_8008: 'error',   // 無法打賞自己
  WALLET_8009: 'error',   // 打賞評論不能是子評論
  WALLET_8010: 'error',   // NOWPayments 第三方服務錯誤

  // 訂閱相關錯誤
  IDOL_9001: 'error',     // 已經有有效訂閱
  IDOL_9002: 'error',     // 訂閱記錄不存在
  IDOL_9003: 'error',     // 訂閱狀態錯誤

  // 網路層錯誤
  NETWORK_ERROR: 'error', // 網路連線失敗，請求未送達伺服器（由全域 ServerErrorPage 處理）
  TIMEOUT_ERROR: 'error', // 請求逾時，伺服器未在時限內回應（留在原畫面，由呼叫端的 StatusModal 顯示）

  // HTTP 錯誤狀態碼
  HTTP_400: 'error',      // 錯誤請求
  HTTP_401: 'error',      // 未授權
  HTTP_403: 'error',      // 禁止存取
  HTTP_404: 'error',      // 資源不存在
  HTTP_413: 'error',      // 檔案過大
  HTTP_422: 'error',      // 參數驗證失敗
  HTTP_429: 'error',      // 請求次數過多
  HTTP_500: 'error',      // 伺服器錯誤
  HTTP_502: 'error',      // 閘道錯誤
  HTTP_503: 'error',      // 服務不可用
  HTTP_504: 'error',      // 閘道逾時
};

// 錯誤碼轉換為 MessageModal 狀態
export const getErrorStatus = (errorCode) => {
  return ERROR_CODES[errorCode] || 'error';
};

// 錯誤碼轉換為多語系 key
// 碼缺失時收斂到既有的系統異常碼（與 getErrorStatus 的容錯一致），避免 undefined.toLowerCase() 導致 render 崩潰
export const getErrorMessageKey = (errorCode) => {
  // 非字串（例如 RTK unwrap() 在 rejectWithValue(undefined) 時丟的 { message: 'Rejected' }）
  // 會讓下面的 toLowerCase 在 render 期間 throw，全站沒有 ErrorBoundary，一炸就是白畫面。
  // StatusModal 的呼叫端有 140 餘處，這裡收斂成最後一道防線；呼叫端仍應自行守衛並保留 error 物件的 log。
  if (errorCode && typeof errorCode !== 'string') {
    console.error('getErrorMessageKey: 收到非字串狀態碼', errorCode);
    return 'error_system_9999';
  }
  return `error_${(errorCode || 'SYSTEM_9999').toLowerCase()}`;
};
